import { useReduxState } from 'hooks';
import Router from 'next/router';
import api from 'api';
import { ConfirmButton, ConfirmDeleteButton } from 'components/common';

import { IAdminGroupsUpdate } from './AdminGroups';

interface Props {
  adminGroupId?: number;
  updateGroups?: (obj: IAdminGroupsUpdate) => Promise<void>;
}

const AdminGroupsRemove = ({ adminGroupId, updateGroups }: Props) => {
  const {
    messages,
    pageState,
    serverConfig: { requireReasonWhenDeletingData }
  } = useReduxState();

  const isThisAdminGroup = adminGroupId === pageState.adminGroupId;

  const handleRemove = async (values?: { deletionReason?: string }) => {
    try {
      let url = `/admin/admin-groups${adminGroupId ? `/${adminGroupId}` : ''}`;

      if (values?.deletionReason) {
        const params = new URLSearchParams({
          deletionReason: values.deletionReason
        });
        url += `?${params.toString()}`;
      }

      await api.delete(url);
      if (updateGroups) await updateGroups({});
      if (isThisAdminGroup) Router.push('/admin/admin-groups');
      return true;
    } catch (err) {}
  };

  const message = adminGroupId
    ? messages.adminGroupsRemoveGroupMessage
    : messages.adminGroupsRemoveGroupAllMessage;
  const success = adminGroupId
    ? messages.adminGroupsRemoveGroupSuccess
    : messages.adminGroupsRemoveGroupAllSuccess;
  const text = adminGroupId
    ? messages.adminGroupsRemoveGroup
    : messages.adminGroupsRemoveGroupAll;

  return requireReasonWhenDeletingData ? (
    <ConfirmDeleteButton
      buttonIsDropdown={true}
      buttonText={text}
      confirmText={message}
      confirmTitle={text}
      id={`deletionReasonAdminGroup-${adminGroupId || 'all'}`}
      onConfirm={handleRemove}
      stopPropagation={true}
      successMessage={success}
    />
  ) : (
    <ConfirmButton
      actionText={messages.commonRemove}
      buttonIcon="trash-alt"
      buttonIsDropdown={true}
      buttonSize="header"
      buttonStyle={{ whiteSpace: 'nowrap' }}
      buttonText={text}
      category="danger"
      confirmText={message}
      confirmTitle={text}
      onConfirm={handleRemove}
      stopPropagation={true}
      successMessage={success}
    />
  );
};

export default AdminGroupsRemove;
